export default __webpack_public_path__ + "static/media/information--lodging--g1.b607f4af.png";